import { AppBar, MenuItem, TextField } from '@mui/material';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import headerImage from 'assets/images/header.png';
import { OrganizationAutocomplete } from 'components/OrganizationAutocomplete';
import { colors } from 'config/theme';

export const Link = styled(NavLink)`
  text-decoration: none;
  font-weight: 700;
  font-size: 14px;
  color: white;
  display: flex;
  align-items: center;
  height: 100%;
  border-bottom: 5px solid transparent;
  &.current {
    border-bottom: 5px solid white;
  }

  :hover {
    border-bottom: 5px solid white;
  }
`;

export const LinkWrapper = styled(MenuItem)`
  height: 100%;
  padding: 0px 20px;
`;
export const BreadcrumbRow = styled.div`
  padding: 15px 15px 0px 30px;
`;

export const RabbitAppBar = styled(AppBar)`
  background: #1f305a;
  box-shadow: none;
  color: white;
  border-bottom: 2px solid ${colors.lightGray};
  background-image: url(${headerImage});
  background-repeat: no-repeat;
  background-position-x: right;
  background-size: auto 100%;
`;

export const StyledOrganizationAutocomplete = styled(OrganizationAutocomplete)`
  color: 'purple';
  '&[class*="muioutlinedinput-root"] .muiautocomplete-input:first-child': {
    // Default left padding is 6px
    paddingleft: 26;
  }
  '& .muioutlinedinput-notchedoutline': {
    bordercolor: 'green';
  }
  '&:hover .muioutlinedinput-notchedoutline': {
    bordercolor: 'red';
  }
  '&.mui-focused .muioutlinedinput-notchedoutline': {
    bordercolor: 'purple';
  }
`;

export const StyledTextField = styled(TextField)`

color: "purple";
'&[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input:first-child': {
  // Default left padding is 6px
  borderColor: "red"
};
'&[class*="MuiAutocomplete-root"] .MuiAutocomplete-root:first-child': {
  // Default left padding is 6px
  color: "red
};
"& .MuiOutlinedInput-notchedOutline": {
  borderColor: "green"
};
"&:hover .MuiOutlinedInput-notchedOutline": {
  borderColor: "red"
};
"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
  borderColor: "purple"
}
`;
